import { Typography } from "@mui/material";
import { capitalize } from "lodash";
import React, { JSX } from "react";
import { tl } from "../../../../components/translate";
import { getDisplayAgeFromDOB, separateByComma } from "../../../../helpers/formatters";
import { Client } from "../../../../interfaces/ClientInterface";
import { clientFullNameSelector } from "../../../../reducers/client";
import { getLocalDateInAD } from "../BillPrintHelpers";
import InfoField from "./InfoField";
import { getCustomerNumber } from "../../../Client/ClientList";

interface ClientInfoProps {
  client: Client;
  customerNumber: string;
  showDobOnPrint: boolean;
}

export const getGenderCode = (gender: string, showFullGender?: boolean): string => {
  switch (gender) {
    case "1":
      return showFullGender ? "Male" : "M";
    case "2":
      return showFullGender ? "Female" : "F";
    default:
      return "";
  }
};

export const showDOBAndGender = (
  gender: string,
  dob: Date | string,
  showIndividual: boolean = false,
  showFullGender: boolean = false
): string => {
  const age = dob ? getDisplayAgeFromDOB(dob) : "";
  const sex = getGenderCode(gender, showFullGender);
  if (age && sex) return ` ${age}/${sex}`;
  if (age) return showIndividual ? age : ` /${age}`;
  if (sex) return showIndividual ? sex : ` /${sex}`;
  return "";
};

export const ClientInfo: React.FC<ClientInfoProps> = ({
  client,
  customerNumber = null,
  showDobOnPrint = false
}): JSX.Element => (
  <>
    <Typography
      sx={{
        color: "#000",
        textAlign: "left",
        fontSize: "0.3cm",
        fontWeight: 600,
        textTransform: "uppercase"
      }}
    >
      {clientFullNameSelector(client)}
      <span style={{ marginLeft: "5px" }}>{showDOBAndGender(client.gender, client.dob, true)}</span>
    </Typography>
    {customerNumber && (
      <InfoField label="Customer Number" value={getCustomerNumber(customerNumber)} />
    )}
    {client.registrationNo && (
      <InfoField label={tl("bills.registrationNo")} value={client.registrationNo} />
    )}
    {showDobOnPrint && client?.dob && (
      <InfoField label={tl("billPrint.customerDob")} value={getLocalDateInAD(client.dob)} />
    )}
    {(client.address || client.city) && (
      <InfoField
        label="Address"
        value={separateByComma(capitalize(client.address), capitalize(client.city))}
      />
    )}
    {client.phone && (
      <InfoField
        label="Phone No"
        value={client.phone?.startsWith("+977") ? client.phone.substring(4) : client.phone}
      />
    )}
    {client?.panVatNumber && (
      <InfoField label={tl("billing.panVatNo")} value={client.panVatNumber} />
    )}

    {client?.user?.username && <InfoField label={tl("username")} value={client?.user?.username} />}

    {client?.user?.tempPassword && (
      <InfoField label={tl("tempPassword")} value={client?.user?.tempPassword} />
    )}
  </>
);

export default ClientInfo;
